import * as Init from '../init.js';
import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as MINUTE from './minute.res.js'

// 画分钟线
// 分笔成交和买卖盘信息 做单独的chart 
// 根据其按键的状态返回改变窗口 用于重画数据 每个chart仅仅对应一个数据
// 所有数据看板都直接用 table 来显示
const chartName = 'Minute'

// 浮动窗口永远只能有一个存在 无论是菜单还是其他
function showFkinfo(chart, result) {

    const nowLR = DATAS.getfloatLR(result.rect, result.mousePos.x)
    const frect = {
        left: nowLR === 'right' ? result.rect.left : result.rect.left + result.rect.width - 230,
        top: result.rect.top,
        width: 115 * Init.scale,
        height: 175 * Init.scale,
    }
    chart.initFwindow('finfo', frect)
    const fwinLayoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: CLAPI.Utils.mergeObjectOfDeep(MINUTE.CHART_MINUTE_FWIN, CLAPI.ChartRes.CHART_BOARD),
        rectMain: frect
    }
    chart.openFwindow('minu.fwin', 'system.board', fwinLayoutCfg, function (result) {
        //  console.log(result)
    })

    chart.setFwindow('minu.fwin', {
        fields: MINUTE.FIELD_IOMINU,
        datas: result.data
    })

}

function drawMinute(inData, minunums) {

    console.log('Draw ====> Min Line', inData)
    // console.log(JSON.stringify(inData))
    // console.log(inData['minute'])
    // console.log(inData['snapshot'])

    const curChart = Init.getSysChart()
    // 设置为单一窗口 并返回第一个窗口
    // 设置区域中的联动配置 指定名字 根据名字加载不同的联动参数
    const chart = curChart.initChart([chartName])
    // 得到第一个窗口
    const canvas = Init.canvas
    const region = {
        style:  'splitly',
        top:    0,
        left:   0,
        width:  canvas.width,
        height: canvas.height,
        rwidth: 225 * Init.scale,
    }

    // 默认已经设置了交易时间
    // chart.setTradeTimes(CLAPI.STOCK_TRADETIME)
    
    inData.keyWord = DATAS.AinfoToKeyWord(inData['info'])
    chart.setKeyWord(Init.getcurKey(), inData.keyWord.static)

    // 设置最新时间
    const curDate = CLAPI.Utils.getMsecDate(inData['info'].datas.at(-1)[0])
    chart.setTradeDate(curDate)

    // 设置坐标显示信息
    const axisXinfo = MINUTE.IominuToAxisXinfo(inData['minute'])
    chart.setAxisXinfo(axisXinfo.timeInfo, axisXinfo.dateInfo)

    Init.setUserInfo(chartName, 'minuteCharts', minunums)

    // console.log(minus);
    chart.setData('MINUTE', MINUTE.IominuToMinute(inData['minute']))

    chart.setData('SNAPSHOT', MINUTE.snapshotToSnap(inData['snapshot']))
    chart.setData('NEARTICK', MINUTE.snapshotToTick(inData['neartick']))

    // 设置界面信息和绑定数据
    // 设置画布尺寸
    // 设置画布区域布局
    const mainLayoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: CLAPI.Utils.mergeObjectOfDeep({
                axisX: {
                    lines: getAxisXlines(minunums),
                },
            },
            MINUTE.CHART_MINU_MAIN),
        rectMain: CLAPI.getChartRect(region, 2, 3, 0, 0),
    }
    const mainchart = chart.createChart('user.minu', 'system.fixed', mainLayoutCfg, function (result) {
        // console.log(result)
        if (result.event === 'mousemove') {
            showFkinfo(chart, result)
        }
        if (result.event === 'mouseout') {
            chart.stopFwindow()
        }
        if (result.key === 'ArrowUp' || result.key === 'ArrowDown') {
            const curminus = Init.getUserInfo(chartName, 'minuteCharts')
            if (result.key === 'ArrowUp') {
                if (curminus > 1) {
                    Init.setUserInfo(chartName, 'minuteCharts', curminus - 1)
                    onLoad()
                }
            }
            if (result.key === 'ArrowDown') {
                if (curminus < 10) {
                    Init.setUserInfo(chartName, 'minuteCharts', minunums + 1)
                    onLoad()
                }
            }
            // console.log('====', result.key, minunums, Init.getUserInfo(chartName, 'minuteCharts'));
        }
    })
    chart.bindData(mainchart, 'MINUTE')

    const volumeLoyoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: CLAPI.Utils.mergeObjectOfDeep({
                axisX: {
                    lines: getAxisXlines(minunums),
                    display: 'none',
                },
            },
            CLAPI.ChartRes.CHART_FIXED_SECOND),
        rectMain: CLAPI.getChartRect(region, 2, 3, 0, 1)
    }
    const volumechart = chart.createChart('user.minuv', 'system.fixed', volumeLoyoutCfg, function (result) {
        //  console.log(result)
    })
    chart.bindData(volumechart, 'MINUTE')

    const analyLayoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: CLAPI.Utils.mergeObjectOfDeep({
                axisX: {
                    lines: getAxisXlines(minunums),
                    left: {
                        display: minunums == 1 ? 'normal' : 'none',
                    },
                    right: {
                        display: minunums == 1 ? 'normal' : 'none',
                    }
                },
            },
            MINUTE.CHART_MINUANALY),
        rectMain: CLAPI.getChartRect(region, 2, 3, 0, 2)
    }
    const analychart = chart.createChart('user.line', 'system.fixed', analyLayoutCfg, function (result) {
        //  console.log(result)
    })
    chart.bindData(analychart, 'MINUTE')

    /////////////////////////////////
    // 下面开始设置数据看板信息
    /////////////////////////////////

    const boardRect = CLAPI.getChartRect(region, 2, 1, 1, 0)
    const snapHeight = boardRect.height * 0.18
    const snapLayoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: CLAPI.Utils.mergeObjectOfDeep(MINUTE.CHART_BOARD_SNAP, CLAPI.ChartRes.CHART_BOARD),
        rectMain: {
            left: boardRect.left,
            top: boardRect.top,
            width: boardRect.width,
            height: snapHeight
        }
    }
    const snapchart = chart.createChart('user.snap', 'system.board', snapLayoutCfg, function (result) {
        //  console.log(result)
    })
    chart.bindData(snapchart, 'SNAPSHOT')

    const rmmpHeight = boardRect.height * 0.52
    const rmmpLayoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: CLAPI.Utils.mergeObjectOfDeep(MINUTE.CHART_BOARD_RMMP, CLAPI.ChartRes.CHART_BOARD),

        rectMain: {
            left: boardRect.left,
            top: boardRect.top + snapHeight,
            width: boardRect.width,
            height: rmmpHeight
        }
    }
    const rmmpchart = chart.createChart('user.rmmp', 'system.board', rmmpLayoutCfg, function (result) {
        //  console.log(result)
    })
    chart.bindData(rmmpchart, 'SNAPSHOT')

    const tickLayoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: CLAPI.Utils.mergeObjectOfDeep(MINUTE.CHART_BOARD_TICK, CLAPI.ChartRes.CHART_BOARD),
        rectMain: {
            left: boardRect.left,
            top: boardRect.top + snapHeight + rmmpHeight,
            width: boardRect.width,
            height: boardRect.height - snapHeight - rmmpHeight
        }
    }
    const tickchart = chart.createChart('user.tick', 'system.board', tickLayoutCfg, function (result) {
        //  console.log(result)
    })
    chart.bindData(tickchart, 'NEARTICK')
    // console.log(boardRect.height, snapHeight, rmmpHeight, 
    //     snapLayoutCfg.rectMain, rmmpLayoutCfg.rectMain, tickLayoutCfg.rectMain);

    curChart.onPaint()
}

function getAxisXlines(minunums) {
    if (minunums < 2) {
        return minunums * 4 - 1
    } else if (minunums < 4) {
        return minunums * 2 - 1
    } else {
        return minunums - 1
    }
}
// console.log(DATAS.fieldsToFieldsIndex(MINUTE.snapshot_fields));
export function onLoad() {
    function onLoadData(curKey, inData) {
        console.log(inData.info.datas, inData.info.datas[0]);

        const lastDate = CLAPI.Utils.getMsecDate(inData['info'].datas.at(-1)[0]);

        // console.log(DATAS.fieldsToFieldsIndex(MINUTE.snapshot_fields));
        let cmds = {}
        cmds['snapshot'] = {
            "cmd": "get",
            "subject": curKey + ".stk_snapshot",
            "service": "snodb",
            "info": {
                "sub-date": lastDate,
                offset: -1
            }
        }
        cmds['neartick'] = {
            "cmd": "get",
            "subject": curKey + ".stk_snapshot",
            "service": "snodb",
            "info": {
                "sub-date": lastDate,
                "fields": MINUTE.tick_fields,
                offset: -100
            }
        }
        for (let index = 0; index < inData['info'].datas.length; index++) {
            let curDate = CLAPI.Utils.getMsecDate(inData['info'].datas[index][0]);
            if (curDate > 20000101) {
                cmds['minute' + index.toString()] = {
                    "cmd": "get",
                    "subject": curKey + ".inout_minu1",
                    "service": "atdb/iodate",
                    "info": {
                        "sub-date": curDate,
                        "fields": MINUTE.iominute_fields
                    }
                }
            }
        }
        console.log(cmds);
        Init.sendCommand({
                cmds: cmds
            },
            function reply(redatas) {
                if (Init.checkDatas(redatas)) {
                    inData['minute'] = []
                    for (let key in redatas) {
                        if (key !== 'snapshot' && key !== 'neartick') {
                            inData['minute'].push(CLAPI.Utils.copyJsonOfDeep(redatas[key]))
                        } else {
                            inData[key] = redatas[key]
                        }
                    }
                    // console.log('====', minunums, inData);
                    drawMinute(inData, inData['minute'].length)
                }
            });
    }
    let curKey = Init.getcurKey()
    let minuteCharts = Math.min(Init.getUserInfo(chartName, 'minuteCharts', 1), 10)
    // minuteCharts = 1
    Init.sendCommand({
            cmds: {
                "info": {
                    "cmd": "get",
                    "subject": curKey + ".alpha_info",
                    "service": "merge/ainfo",
                    "info": {
                        "offset": -1 * minuteCharts
                    }
                }
            }
        },
        function reply(datas) {
            if (Init.checkDatas(datas)) {
                Init.setcurKey(curKey);
                onLoadData(curKey, datas)
            }
        });
}

// const result = mergeObjectOfDeep(MINUTE.CHART_BOARD_SNAP, CLAPI.ChartRes.CHART_BOARD);
// console.log(result);

// [1742259783000,\"SZ301479\",\"N弘景光电\",50,0.000,0.01,41.90,41.90,0,0,0,1.000000,63546665,14203437,2.5999,9.2846,109193,19461